import Vue from 'vue'
import VueRouter from 'vue-router'
import navConfig from './conf/nav'
Vue.use(VueRouter)

let routes = [] // 路由配置表

function handleRouterConfig (conf) {
  let path = '/' + conf.path
  let name = conf.path.replace(new RegExp('\\/', 'g'), '_')

  let component = resolve => require(['./view/' + conf.component], resolve)
  let redirect = conf.redirect
  let route = { path, name, component, redirect }

  if (conf.children && conf.children instanceof Array)
  {
    route.children = []
    for (let child of conf.children)
    {
      let childRoute = handleRouterConfig(child)
      if (typeof childRoute !== 'undefined')
      {
        route.children.push(childRoute)
      }
    }
  }
  return route
}
function isValidJSON (text) {
  try
  {
    JSON.parse(text);
    return true;
  } catch (e)
  {
    if (e instanceof SyntaxError)
    {
      return false;
    }
    // 重新抛出其他非JSON解析错误
    throw e;
  }
}

navConfig.map(nav => {
  let route = handleRouterConfig(nav)
  routes.push(route)
})

const router = new VueRouter({
  mode: 'history',
  routes
})

/**
 * 路由跳转之前的钩子
 */
router.beforeEach((to, from, next) => {
  console.log(to.path, 'to.path ')
  let token = localStorage.getItem('token')
  let certificationStatus = localStorage.getItem('certificationStatus')
  let userInfo = localStorage.getItem('userInfo') && isValidJSON(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')) : ''
  // localStorage.setItem("userInfo", JSON.stringify(res.data));
  if (token && certificationStatus == 3 && userInfo.realnameStatus == 3)
  {
    // if (to.path === '/login') {

    // } else {

    // }
    next()
  } else
  {
    if (to.path === '/login' || to.path === '/signup' || to.path === '/revisePass' || to.path === '/privacy' || to.path === '/privacyferter')
    {
      next()
    } else
    {
      if (token && (to.path === '/wanshan' || to.path === '/enterprisecertification'))
      {
        next()
      } else
      {
        if (token && userInfo.businessId)
        {
          if (certificationStatus != 3 || userInfo.realnameStatus != 3)
          {
            next('/enterprisecertification')
          } else
          {
            next('/login')
          }
        } else if (token && !userInfo.businessId)
        {
          next('/wanshan')
        } else
        {
          next('/login')
        }
      }
      // Vue.prototype.$message.warning('登录失效！')

    }
  }
})


export default router



// WEBPACK FOOTER //
// ./src/router.js